import { render, staticRenderFns } from "./DashBoardMain.vue?vue&type=template&id=acd003a0&scoped=true&"
import script from "./DashBoardMain.vue?vue&type=script&lang=js&"
export * from "./DashBoardMain.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardMain.vue?vue&type=style&index=0&id=acd003a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd003a0",
  null
  
)

export default component.exports